import { getLocalStorageTokenKey } from '../utils/localStorage';

export default {

    render() {
        return null;
    },

    mounted() {
        const token = this.$route.params.token;

        // Set the token
        localStorage.setItem(getLocalStorageTokenKey(), token);

        // Hard refresh
        window.location = window.DESIGNER_PATH || '/';
    },
};
